import {PartnerSelectionItem} from "@/store/types";

export interface CallIvrMenusState {
    ivrMenus: IvrMenus[],
    ivrMenuItem?: IvrMenuItem
}

export interface IvrMenus {
    id: number,
    name : string,
    path : string,
    description : string
}


export class IvrMenuFilter {
    id?:number;
    name?: string;
    page_number: number = 1;
}

export interface IvrMenuItem {
    id?: number | null;
    name: string | null;
    path: string | null;
    service_number: string | null;
    partner_id: number | null;
    partners: PartnerSelectionItem[];
    partner_ids: (number| undefined)[];
    description: string | null;
}
